export default __webpack_public_path__ + "static/media/icon-love-poppy-active.f59136d2.webp";